import { render, staticRenderFns } from "./insTypeFastResult.vue?vue&type=template&id=65786ff2"
import script from "./insTypeFastResult.vue?vue&type=script&lang=js"
export * from "./insTypeFastResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports